export const siteSettings = {
  name: "Coin Quote",
  link: "https://c-quote.com",
  email: "support@c-quote.com",
  appLink: "https://app.c-quote.com",
};
